function useDropdownStyle(_ref) {
  var open = _ref.open;
  var styleProps = {
    borderWidth: 'border-0',
    padding: 'p-2',
    borderRadius: 'rounded-md',
    boxShadow: 'shadow-menu',
    overflow: 'overflow-auto',
    maxHeight: 'max-h-96',
    zIndex: 'z-50',
    display: open ? 'block' : 'hidden'
  };
  return styleProps;
}

export { useDropdownStyle };
//# sourceMappingURL=use-dropdown-style.esm.js.map
